export const ePortCode = {
  paymentAgreement: 1,
  modeOfTransport: 2,
  deliveryAgreement: 3,
  department: 4,
  productGroup: 5,
  profile: 6,
  country: 7,
  language: 8,
  account: 9,
  ourVATNo: 10,
  externalWarehouse: 11,
};
